const e=(e=0)=>""===e?0:"string"==typeof e?Number(e.replace(/[$,\s]*/g,"")):e;export{e as floatPriceFromFormatted};
//# sourceMappingURL=floatPriceFromFormatted.js.map
